import type { IndexDefinition } from '../../models/indexes';

export function normalizeIndexDefinition(index: IndexDefinition) {
  index = structuredClone(index);

  if (index.spec.sparse) {
    const key = Object.keys(index.spec.key)[0];
    if (key !== undefined) {
      index.spec.partialFilterExpression ??= {};
      index.spec.partialFilterExpression[key] = { $exists: true };
    }
  }

  for (const key of Object.keys(index.spec.partialFilterExpression || {})) {
    delete index.spec.key[key];
  }

  return index;
}
